import styled, { css } from "styled-components";

export const ConfigurableUserCardContainer = styled.div<{
  completeCard: boolean;
}>`
  width: 100%;
  display: flex;
  cursor: pointer;
  user-select: none;
  position: relative;

  .ant-progress {
    .ant-progress-inner {
      .ant-progress-circle {
        border-radius: 100px;

        .ant-progress-circle-trail {
          stroke: none !important;
        }
      }
    }
  }

  .wrapper {
    width: 100%;
    display: flex;
    padding: 25px;
    position: relative;
    border-radius: 6px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    transform: scale(1);
    transition: all ease-in-out 0.2s;

    .image-container-configurable-user-card {
      position: relative;
      width: 7.5rem;
      height: 7.5rem;

      div {
        width: 100%;
        height: 100%;
      }

      h1 {
        margin: 0;
        font-size: 2rem;
      }
    }

    ${(props) =>
      props.completeCard
        ? css`
            height: 280px;
            box-shadow: 15px 15px 30px rgba(0, 0, 0, 0.05);
            background: ${({ theme }) =>
              theme.mode === "dark"
                ? "rgba(15, 15, 15, 0.8)"
                : "rgba(255, 255, 255, 0.7)"};
            backdrop-filter: blur(30px);

            img.user-photo {
              width: 110px;
              height: 110px;
              object-fit: cover;
              user-select: none;
              border-radius: 50%;
              -webkit-user-drag: none;
            }
          `
        : css`
            img.user-photo {
              width: 130px;
              height: 130px;
              object-fit: cover;
              user-select: none;
              border-radius: 50%;
              -webkit-user-drag: none;
            }
          `}

    h3.name {
      z-index: 3;
      width: 100%;
      font-size: 19px;
      overflow: hidden;
      margin: 18px 0 0;
      text-align: center;
      position: relative;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      color: ${({ theme }) => theme.colors.textColor} !important;
    }

    p.bio {
      font-size: 16px;
      margin: 15px 0 0;
      font-weight: 300;
      overflow: hidden;
      line-height: 22px;
      text-align: center;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      color: ${({ theme }) => theme.colors.textColor} !important;
    }
  }

  &:hover {
    .wrapper {
      transform: scale(1.1);
    }
  }
`;
